import React, { Component } from 'react'

import classes from './ImageInput.scss'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'

import Image from '../../../Image/Image'

import imagePlaceHolder from '../../../../assets/image-placeholder.png'

class ImageInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      src: props.src || imagePlaceHolder
    }

    this.imageInputRef = React.createRef()
  }

  browseFile = () => {
    this.imageInputRef.current.click()
  }

  imageChangeHandler = e => {
    const file = e.target.files[0]
    let fileSrc = null
    if (file) {
      fileSrc = URL.createObjectURL(file)
    }

    this.setState({
      src: fileSrc
    })

    this.props.changed(e)
  }

  render() {
    const { imgAlt, configs } = this.props

    let input = (
      <Image
        src={this.state.src}
        imgAlt={imgAlt}
        variant={'circle'}
        clicked={this.browseFile}
        {...configs}
      />
    )

    return (
      <Aux>
        {input}
        <div className={classes.ImageInput}>
          <input
            type={'file'}
            ref={this.imageInputRef}
            onChange={this.imageChangeHandler}
            accept={'image/*'}
          />
        </div>
      </Aux>
    )
  }
}

export default ImageInput
